import { SignupBackgroundLayout } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { RovoDevAgentsLogo } from "@/components/signup/utils";

import { ExistingUserWithPaymentSwitcher } from "../../components/payment";

export const LoggedInRovoDevStandardExistingSitesUser = () => {
    return (
        <SignupBackgroundLayout
            theme="green"
            ProductLogo={<RovoDevAgentsLogo />}
        >
            <SiteActivation
                ExistingUser={<ExistingUserWithPaymentSwitcher />}
                WeekOneUser={null}
                ManagedUser={null}
            />
        </SignupBackgroundLayout>
    );
};
